<template>
    <div class="wrapper blog-posts">
        <div class="page-header page-header-small signup-page section-image">
            <parallax class="page-header-image" style="background-image: url('img/homepage/usReviewHero.jpg') ;">
            </parallax>
            <div class="content-center">
                <div class="row">
                    <div class="col-md-8 ml-auto mr-auto text-center">
                        <h2 class="title">USA Review</h2>
                        <h4>Betting Companies Review in each US state</h4>

                    </div>
                </div>
            </div>
        </div>
        <div class="main">
            <div class="container">
                <div class="section">
                    <!-- <h3 class="title text-center">You may also be interested in</h3> -->
                    <br/>
                    
                <div class="row">
                    <div class="col-md-8">

                <!-- Content of Review -->
                <!-- <p>Iowa sports betting is here.</p>
                <p>The state legalized wagering as of May 2019 and went live with retail and online betting in August 2019. The new portion of the Iowa gaming industry is overseen by the Iowa Racing and Gaming Commission. </p>
                <p>Read on for more about the present and future of Iowa sports betting.</p>

                <h3>Sports betting apps in Iowa</h3>
                <p>
                    Online sports betting launched in Iowa in August 2019. Thirteen of the 19 casinos in the state now offer online wagering through six websites.
                </p>
                <p>
                    Patrons must go to one of the casinos attached to the sports betting app to register for mobile Iowa sports betting accounts in-person through 2020. Once the account is established in person, wagers can be made from anywhere in the state.
                </p> -->

                <!-- <h3>Betting Companies Review in each US state</h3> -->

                    <div v-for='blog in blogs' :key="blog.id" >
                        <card type="blog" plain>
                            <div class="row">
                                <div class="col-md-12">
                                    <h3 class="title">
                                        <router-link v-bind:to="{name: 'USA-Review-Detail', params: { state_id: blog.state }}">
                                            {{blog.state}} Bookmaker Reviews
                                        </router-link>
                                    </h3>
                                    <p class="card-description">
                                       <!-- {{blog.contentFront}} -->
                                       <div v-html="blog.contentFront" />
                                    </p>
                                </div>
                            </div>
                        </card>
                    </div>

                <!-- End Content of Review -->

                    </div>
                    <!-- SIDEBAR BEGINS -->
                    <div class="col-md-4">
                       <sidebar></sidebar>
                    </div>
                    <!-- SIDEBAR ENDS -->
                </div>



                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import { Card, Button, FormGroupInput } from '@/components';
  import { Carousel, CarouselItem, Table, TableColumn } from 'element-ui'
  import Sidebar from '@/pages/bet/sidebarUs';
  import db from '../../components/Firebase/firebaseInit'

  export default {
    name: 'blog-posts',
    bodyClass: 'blog-posts',
    components: {
      Card,
      Sidebar,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Button.name]: Button,
      [FormGroupInput.name]: FormGroupInput
    },
    data() {
      return {
        year: new Date().getFullYear(),
        blogs: []
      }
    },
    created(){
    db.collection('usaStates').orderBy('order').get()
    .then(querySnapshot => {
      querySnapshot.forEach(doc => {
        const data = {
          'id': doc.id,
          'state': doc.data().name,
          'contentFront': doc.data().contentFront
        }
        this.blogs.push(data)
      })
    })
    }
  }
</script>
<style>
</style>
